<template>
  <div>
    <FrameHeader/>
    <div class="boxed pt-5">
      <h2 
        v-if="!status_ajaxing_list"
        class="tac"
        >
        {{nft_name}}
      </h2>

      <!-- <div v-if="status_ajaxing_list" class="tac t-gray py-4">
        Loading...
      </div> -->
      <div class="list-main-prod pb-5">
        <div class="item mb-4" v-for="(item,index) of list_on_show" :key="index">
          <CpCardProd :data="item"/>
        </div>
      </div>
      <div style="height: 20px;">
        <div v-if="status_ajaxing_list" class="t-gray tac">
          Loading... 
        </div>
        <CpLoadOnScroll 
          :fn_load_data="listData"
          :status_no_more_data="status_no_more_data"
        />
      </div>

    </div>
    <FrameFooter/>
  </div>
</template>

<script>

export default {
  name: 'assetsuit',
  components: {},
  props: [],
  data() {
    return {
      status_ajaxing_list: false,
      list_on_show: [],
      status_no_more_data: false,
      next_page_num: 1,

      nft_name: '',
    }
  },
  computed: {},
  watch: {},
  methods: {
    
    async listData(){
      let v = this

      let keystr = v.$route.params.address

      if(!keystr){
        return
      }

      let res = await v.api('list_asset_suit',{
        keyword: keystr,
        page_num: v.next_page_num,
      },{
        vue: v,
        key_ajaxing: 'status_ajaxing_list',
        // key_data: 'list_on_show',
      })

      if(res && res.data && res.data.length){
        v.list_on_show = v.list_on_show.concat(res.data)
        v.next_page_num += 1
      }else{
        v.status_no_more_data = true
      }

      if(v.list_on_show[0]){
        v.nft_name = v.list_on_show[0].nft_name
      }
    },
  },
  created() {
    this.listData()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>